const toTitleCase = (phrase) => {
  return phrase
    .toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

/**
 * Expects an array of object and a key. Returns an array such that values are unique against the key
 * [{key:value}], key:string => [value]
 */
const getUniqueValues = (rows, key) => {
  const result = [];
  rows.forEach((row) => {
    if (!result.includes(row?.[key]) && row?.[key] !== undefined) {
      result.push(row[key]);
    }
  });
  return result;
};

const round = (number, placesAfterDecimal) => {
  return (
    Math.round(number * 10 ** placesAfterDecimal) / 10 ** placesAfterDecimal
  );
};

const alphabeticalSort = (a, b, key) => {
  const nameA = a[key].toLowerCase();
  const nameB = b[key].toLowerCase();

  if (nameA < nameB) return -1;
  if (nameA > nameB) return 1;
  return 0;
}

export { toTitleCase, getUniqueValues, round, alphabeticalSort };
